import { AfterViewInit, Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { FinancialCompany } from '@gipi-financial/company/models/company.model';
import { FinancialCompanyService } from '@gipi-financial/company/services/company.service';
import { FinancialProvider } from '@gipi-financial/provider/models/provider.model';
import { CustomAuthenticationService } from '@gipi-shared/services/custom-authentication.service';
import { CustomMessageService } from '@gipi-shared/services/custom-message.service';
import { AbstractComponent, ArrayUtil, CurrencyUtil, GIPIUuid, ObjectUtil, StringUtil } from '@gipisistemas/ng-core';

@Component({
    selector: 'itss-payment-voucher',
    templateUrl: './payment-voucher.component.html',
    styleUrls: ['./payment-voucher.component.scss']
})
export class PaymentVoucherComponent extends AbstractComponent implements OnInit, AfterViewInit {

    public company: FinancialCompany = null;

    public provider: FinancialProvider;

    public description: string = '';

    public comments: string = '';

    public amountPaid: number;

    public paymentDate: Date;

    public documentNumber: string = '';

    public isTwoWays: boolean = false;

    public isCreated: EventEmitter<void> = new EventEmitter();

    constructor(
        private _companyService: FinancialCompanyService,
        private _customAuthenticationService: CustomAuthenticationService,
        messageService: CustomMessageService,
        router: Router,
        activatedRoute: ActivatedRoute
    ) {
        super(messageService, router, activatedRoute);
    }

    async ngOnInit(): Promise<void> {
        await this.findCompanyData();
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.isCreated.emit(), 1000);
    }

    async findCompanyData(): Promise<void> {
        try {
            const companyId: GIPIUuid = this._customAuthenticationService.token.user.currentCompany;
            await this._companyService.findByIdIn([Number(companyId)]).toPromise().then(companyList => {
                if (!ArrayUtil.isEmpty(companyList)) {
                    this.company = companyList[0];
                    this.isCreated.emit();
                }
            }, error => {
                throw new Error(error);
            });
        } catch (e) {
            this.handleError(e);
        }
    }

    public getCpfOrCnpjCompany(): string {
        if (
            ObjectUtil.isNull(this.company) ||
            (!ObjectUtil.isNull(this.company) && ObjectUtil.isNull(this.company.person))
        ) {
            return '';
        }

        const person = this.company.person;
        if (!ObjectUtil.isNull(person.legalPerson)) {
            return !StringUtil.isEmpty(person.legalPerson.cnpj) ? StringUtil.format(person.legalPerson.cnpj, '00.000.000/0000-00') : '';
        } else if (!ObjectUtil.isNull(person.naturalPerson)) {
            return !StringUtil.isEmpty(person.naturalPerson.cpf) ? StringUtil.format(person.naturalPerson.cpf, '000.000.000-00') : '';
        }

        return '';
    }

    public getCpfOrCnpjProvider(): string {
        if (
            ObjectUtil.isNull(this.provider) ||
            (!ObjectUtil.isNull(this.provider) && ObjectUtil.isNull(this.provider.person))
        ) {
            return '';
        }

        const person = this.provider.person;
        if (!ObjectUtil.isNull(person.legalPerson)) {
            return !StringUtil.isEmpty(person.legalPerson.cnpj) ? StringUtil.format(person.legalPerson.cnpj, '00.000.000/0000-00') : '';
        } else if (!ObjectUtil.isNull(person.naturalPerson)) {
            return !StringUtil.isEmpty(person.naturalPerson.cpf) ? StringUtil.format(person.naturalPerson.cpf, '000.000.000-00') : '';
        }

        return '';
    }

    public getAmountPaidInFull(): string {
        const amountPaidFormatted: string = CurrencyUtil.transform(this.amountPaid, '1.2-2');
        const amountPaidNotCurrency: string = amountPaidFormatted.substring(2).trim();
        return `${amountPaidFormatted} (${amountPaidNotCurrency.numberFullName(true)})`;
    }

    public getDescription(): string {
        if (!StringUtil.isEmpty(this.comments)) {
            return this.comments;
        } else if (!StringUtil.isEmpty(this.description)) {
            return this.description;
        }

        return '';
    }

    public formatDateInFull(): string {
        const date = new Date(this.paymentDate);
        const dayNumber = date.getDate();
        const year = date.getFullYear();
        const day = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'][date.getDay()];
        const month = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'][date.getMonth()];
        return `${day}, ${dayNumber} de ${month} de ${year}`;
    }

}
